<div class="fb-dialog">
  <h2 mat-dialog-title class="fb-dialog__title">{{ 'MODAL.OTP_TITLE' | translate:{titulo: data.titulo} }}</h2>

  <p class="fb-otp__intro">{{ 'MODAL.OTP_INTRO' | translate }}</p>

  <form name="form" (ngSubmit)="finish()" [formGroup]="form" novalidate class="fb-otp__body">
    <label class="fb-label" for="codigoSeguridad">{{ 'MODAL.OTP_CODE' | translate }}<span class="fb-req">*</span></label>
    <input id="codigoSeguridad" autocomplete="off" type="text" name="codigoSeguridad"
           class="fb-input" formControlName="codigoSeguridad" maxlength="6"
           [placeholder]="'MODAL.OTP_PH' | translate" />
    <small class="fb-hint-text" *ngIf="form.controls['codigoSeguridad'].invalid && form.controls['codigoSeguridad'].touched">
      {{ 'MODAL.OTP_HINT' | translate }}
    </small>

    <mat-dialog-actions class="fb-dialog__actions">
      <button type="button" class="fb-btn fb-btn--ghost" (click)="cancel()">{{ 'COMMON.CANCEL' | translate }}</button>
      <button type="submit" class="fb-btn fb-btn--primary" [disabled]="form.invalid">{{ 'COMMON.CONFIRM' | translate }}</button>
    </mat-dialog-actions>
  </form>
</div>
